<template>
  <div class="position-relative">
    <b-form-input
      :value="value"
      :id="id"
      type="number"
      class="cost-input"
      no-wheel
      v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
      :title="tooltip"
      @input="$emit('input', Number($event))"
    />
    <span class="currency-code">{{ currencyCode }}</span>
  </div>
</template>

<script>
export default {
  name: 'CostInput',
  props: {
    value: Number,
    currencyCode: {
      type: String,
      required: true
    },
    tooltip: String,
    id: String
  }
}
</script>

<style scoped lang="scss">
.cost-input {
  padding-right: 35px;
  text-align: right;
}

.currency-code {
  font-family: $font-family-second;
  position: absolute;
  top: 5px;
  right: 10px;
  pointer-events: none;
}
</style>
